const PAGES = {
  StagePersonal: 'PersonalInfos',
  StageContact: 'ContactInfos',
  StageBank: 'BankInfos',
  StageDocs: 'DocsInfos',
  StageValidation: 'Validation',
}

export default {
  data() {
    return {
      pages: [
        PAGES.StagePersonal,
        PAGES.StageContact,
        PAGES.StageBank,
        PAGES.StageDocs,
        PAGES.StageValidation,
      ],
    }
  },
  computed: {
    currentPage() {
      return this.$route.params.page || PAGES.StagePersonal
    },
    pageTitle() {
      return `subscription.page-title.${this.currentPage}`
    },
    stageTitle() {
      return `subscription.stage-title.${this.currentPage}`
    },
    stageSubTitle() {
      return `subscription.stage-subtitle.${this.currentPage}`
    },
    previousPage() {
      const currentPageIndex = this.currentPageIndex
      if (currentPageIndex <= 0) {
        return null
      }

      return this.pages[currentPageIndex - 1]
    },
    nextPage() {
      const currentPageIndex = this.currentPageIndex
      if (currentPageIndex >= this.pageCount - 1) {
        return null
      }

      return this.pages[currentPageIndex + 1]
    },
    currentPageIndex() {
      const currentPageIndex = this.pages.indexOf(this.currentPage)

      return currentPageIndex
    },
  },
}
